import { Calendar, MapPin, Users, Mic, Monitor, MessageSquare } from "lucide-react";

const highlights = [
  { icon: Mic, label: "Keynote Sessions", desc: "Industry leaders sharing insights on AI and emerging tech" },
  { icon: MessageSquare, label: "Panel Discussions", desc: "Interactive conversations on innovation and adaptability" },
  { icon: Monitor, label: "Live Demonstrations", desc: "Hands-on experience with cutting-edge technologies" },
  { icon: Users, label: "Networking", desc: "Connect with tech leaders, educators, and policymakers" },
];

const EventDetails = () => {
  return (
    <section id="event" data-testid="event-section" className="py-24 md:py-32 bg-zinc-900/30">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Left - Event Info */}
          <div className="lg:col-span-5">
            <span className="section-label">Upcoming Event</span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tighter text-white mt-4">
              ICT Summit Oke-Ogun{" "}
              <span className="gradient-text">2026</span>
            </h2>
            <p className="text-zinc-400 text-base sm:text-lg mt-6 leading-relaxed">
              More than a conference - it is a call to innovate, adapt, and lead the future.
              Under the theme "In the Age of AI," we will explore how artificial intelligence,
              data, and emerging technologies are reshaping industries, careers, governance, and everyday life.
            </p>

            {/* Details */}
            <div className="mt-8 space-y-4">
              <div className="flex items-center gap-4 text-zinc-300">
                <div className="w-10 h-10 bg-teal-600/10 flex items-center justify-center flex-shrink-0">
                  <Calendar size={18} className="text-teal-500" />
                </div>
                <div>
                  <div className="text-sm text-zinc-500 uppercase tracking-wider">Date</div>
                  <div className="font-semibold">June 27, 2026</div>
                </div>
              </div>
              <div className="flex items-center gap-4 text-zinc-300">
                <div className="w-10 h-10 bg-teal-600/10 flex items-center justify-center flex-shrink-0">
                  <MapPin size={18} className="text-teal-500" />
                </div>
                <div>
                  <div className="text-sm text-zinc-500 uppercase tracking-wider">Venue</div>
                  <div className="font-semibold">Oredegbe Digital Hall, 5, Koleoso Street, Koomi Saki, Oyo State</div>
                </div>
              </div>
              <div className="flex items-center gap-4 text-zinc-300">
                <div className="w-10 h-10 bg-teal-600/10 flex items-center justify-center flex-shrink-0">
                  <Users size={18} className="text-teal-500" />
                </div>
                <div>
                  <div className="text-sm text-zinc-500 uppercase tracking-wider">Capacity</div>
                  <div className="font-semibold">1,500 Free Tickets</div>
                </div>
              </div>
            </div>

            <a
              href="https://hayeni.com/events/oke-ogun-ict-summit-2026-1"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 bg-teal-600 hover:bg-teal-500 text-white px-8 py-4 font-semibold tracking-wide transition-all inline-flex items-center gap-2"
              data-testid="event-register-btn"
            >
              Secure Your Spot
            </a>
          </div>

          {/* Right - Highlights */}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 stagger-children">
              {highlights.map((item) => (
                <div
                  key={item.label}
                  className="bg-zinc-900 border border-zinc-800 p-6 group hover:border-cyan-600/40 transition-all duration-300"
                  data-testid={`highlight-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  <div className="w-10 h-10 bg-cyan-600/10 flex items-center justify-center mb-4 group-hover:bg-cyan-600/20 transition-colors">
                    <item.icon size={20} className="text-cyan-400" />
                  </div>
                  <h3 className="text-lg font-bold text-white mb-2 tracking-tight">{item.label}</h3>
                  <p className="text-zinc-400 text-sm leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>

            {/* Theme Badge */}
            <div className="mt-6 bg-gradient-to-r from-teal-600/10 via-cyan-600/10 to-purple-600/10 border border-teal-600/20 p-6">
              <div className="text-xs uppercase tracking-[0.2em] text-teal-400 font-medium mb-2">
                Theme 2026
              </div>
              <div className="text-2xl sm:text-3xl font-extrabold tracking-tighter text-white">
                "In the Age of AI"
              </div>
              <p className="text-zinc-400 text-sm mt-2 leading-relaxed">
                Exploring how AI and emerging technologies are reshaping industries, careers, governance,
                and everyday life across Nigeria and beyond.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventDetails;
